<template>
  <div class="loader-wrapper">
    <div class="spinner" :style="spinnerStyle"></div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    size: {
      type: String,
      required: true
    },
    color: {
      type: String
    }
  },
  computed: {
    spinnerStyle() {
      const activeColor = this.color ? this.color : "#3b82f6";
      const diameter = this.size || "40px";
      return {
        width: diameter,
        height: diameter,
        borderTopColor: activeColor
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.loader-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.spinner {
  border: 3px solid #e2e8f0;
  border-top: 3px solid #3b82f6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  flex-shrink: 0;
}

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
